import { useContext, useEffect, useState } from "react";
import User, { UserEducation } from "../../../interfaces/user.interface";
import { CBEColumns } from "../../shared/CBEditableTable/CBEColumns.type";
import { CBEditableTable } from "../../shared";
import CustomCard from "../../shared/CustomCard/CustomCard";
import { UserContext } from "../../../context/user.context";
import { Button } from "antd/lib";
import { CheckOutlined } from "@ant-design/icons";
import { updateUser as updateUserDto } from "../../../services/users.service";
import Message from "../../shared/Message/Message";
import { useQueryClient } from "@tanstack/react-query";

const CredentialsTable = () => {
  const queryClient = useQueryClient();
  const { user } = useContext(UserContext);
  const [editable] = useState<boolean>(true);
  const [reset] = useState<boolean>(false);
  const [credentials, setCredentials] = useState<UserEducation[]>(
    user?.educations ?? [],
  );

  useEffect(() => {
    if (user?.educations) {
      setCredentials(user.educations);
    }
  }, [user]);

  const cols: CBEColumns[] = [
    {
      title: "Degree",
      dataIndex: "degree",
      editable: editable,
    },
    { title: "Program/Major", dataIndex: "programMajor", editable: editable },
    { title: "Institution", dataIndex: "institution", editable: editable },
    {
      title: "Year Completed",
      dataIndex: "completionYear",
      editable: editable,
    },
  ];

  const submitHandler = async () => {
    if (user) {
      let profile: User = user;
      profile.educations = credentials;

      try {
        await updateUserDto(profile);
        queryClient.invalidateQueries({
          queryKey: ["isLoggedIn"],
        });

        Message().success(`The update SEABC Profile was successfully`);
      } catch (error) {
        Message().error(`The update SEABC Profile was not successfully`);
      }
    } else {
      Message().error(`No User to update`);
    }
  };

  return (
    <div className="pt-8">
      <CustomCard title="Education & Credentials" className="flex-1">
        <div className="p-4">
          <CBEditableTable
            data={credentials}
            columns={cols}
            addButton={editable}
            handleReset={reset}
            onChange={(data: UserEducation[]) => setCredentials(data)}
          />
        </div>
      </CustomCard>

      <div className="flex justify-center">
        <Button
          type="primary"
          icon={<CheckOutlined />}
          className="w-48"
          onClick={submitHandler}
          disabled={
            JSON.stringify(user?.educations) === JSON.stringify(credentials)
          }
        >
          Save
        </Button>
      </div>
    </div>
  );
};

export default CredentialsTable;
